import React from 'react';
import { RegularButton, Typography } from 'fronton-react';
import { getPriceText } from 'utils';
import { btnStyles, CardPriceWrapper } from './styled';

type CardPriceProps = {
	price: number;
	unit?: string;
	flexiblePrice?: boolean;
	className?: string;
};

export const CardPrice = ({
	price,
	flexiblePrice = true,
	unit = null,
	className = '',
}: CardPriceProps) => (
	<CardPriceWrapper className={className}>
		<div data-analyticsName="productPriceLink">
			{flexiblePrice && (
				<Typography variant="s" size="body_accent">
					от&nbsp;
				</Typography>
			)}
			<Typography variant="l" size="body_accent" data-qa="card-price">
				{getPriceText(price)}
			</Typography>
			<Typography variant="s" size="body_accent" data-qa="card-unit">
				&nbsp;₽{unit && `/${unit}`}
			</Typography>
		</div>
		<RegularButton
			variant="primary"
			size="s"
			className={btnStyles}
			data-qa="card-order-btn"
			data-analyticsName="productButtonLink"
		>
			Заказать
		</RegularButton>
	</CardPriceWrapper>
);
